import { normalizePath } from '@app/utils/functions/normalize-path';

/**
 * Servicios que envian el header numberOfDecimalsBE (CI-21977).
 * Para agregar/quitar un servicio de la integracion, edita SOLO esta lista:
 *  - string: match por url.includes.
 *  - RegExp: match exacto contra la ruta normalizada (sin host, query ni slash final).
 */
export const DECIMALS_SERVICES: (string | RegExp)[] = [
  // Irops
  '/sc/flight/search/v2',
  '/sc/products',
  '/ac/reassign/seat', // sigue en el micro (IROPS)
  '/ac/ancillaries/v2/', // PUT {pnr}: sigue en el micro
  // Ancillaries (BFF de ancillaries: .../kiosk/ancillaries/...). Misma cobertura que tenian
  // /ac/ancillaries/v2 (consulta, upgrade y chubb), /ac/seatmap/v2 y /ac/seat/v3;
  // /ac/chubb/bind (sigue en el micro) no lleva el header.
  /\/v\d+\/kiosk\/ancillaries\/ancillaries-offer-baggage$/,
  /\/v\d+\/kiosk\/ancillaries\/ancillaries-offer-upgrade$/,
  /\/v\d+\/kiosk\/ancillaries\/ancillaries-offer-chubb$/,
  /\/v\d+\/kiosk\/ancillaries\/seatmap-offer-seats$/,
  /\/v\d+\/kiosk\/ancillaries\/seat-seating$/,
  // Pago (BFF de pagos: .../kiosk/payments/...)
  '/payments/emit-ticket/ancillary',
  '/payments/payment-revenue-dc-exchange',
  // '/payments/pectab-receipt',    // recibo: descomentar si el BE requiere el param tambien aqui
];
export const DECIMALS_HEADER = 'numberOfDecimalsBE';
export const DECIMALS_DEFAULT = 2;

/** true si el request debe llevar el header numberOfDecimalsBE (ver DECIMALS_SERVICES). */
export function isDecimalsService(url: string): boolean {
  const path = normalizePath(url);
  return DECIMALS_SERVICES.some((service) =>
    typeof service === 'string' ? url.includes(service) : service.test(path)
  );
}
